
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection2Bars as ObiConnection2BarsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-2-bars.js';
 
 
 

 
 export const ObiConnection2Bars = createComponent({
   react: React,
   tagName: 'obi-connection-2-bars',
   elementClass: ObiConnection2BarsElement,
   events: {
     
   }
  });
 
 